import { eachMonthOfInterval } from 'date-fns';

const getMonthsBetweenDates = (
  startDate: string,
  endDate: string
): string[] => {
  const start = new Date(startDate);
  const end = new Date(endDate);

  return eachMonthOfInterval({
    start,
    end
  }).map((date) => date.toLocaleString('default', { month: 'long' }));
};

export default getMonthsBetweenDates;
